let config = {
  title: 'Configurações',
  title_s: 'Configuração',
  save: 'Salvar',
  menu: {
    sound_alerts: 'Alertas Sonoros'
  },
  app: {
    title: 'Aplicativo',
    info: {
      title: 'Informações do App',
      edition: 'Edição',
      version: 'Versão',
      address: 'Endereço',
      dev_mode: 'Modo Desenvolvimento',
      dev_mode_info: 'Essa função pode causar lentidão no app, <br /> acione o suporte técnico para desativação.',
      server: 'Servidor',
      status: {
        title: 'Status',
        online: 'Conectado',
        offline: 'Desconectado'
      },
      internet: {
        title: 'Internet',
        online: 'Online',
        offline: 'Offline'
      },
      auth: {
        title: 'Autenticação',
        online: 'Autenticado',
        offline: 'Não Autenticado'
      },
      license: {
        title: 'Licença',
        domain: 'Domínio',
        company: 'Registrado para',
        holder: 'Titular',
        status: {
          title: 'Status',
          last: 'dias restantes',
          expired: 'Expirado',
          invalid: 'Inválida'
        }
      }
    },
    form: {
      title: 'Configurações do Aplicativo',
      app_title: 'Título'
    }
  },
  themes: {
    title: 'Temas',
    info: {
      title: 'Tema',
      description: 'Descrição',
      name: 'Nome',
      developer: 'Desenvolvedor',
      status: {
        title: 'Status',
        active: 'Ativo',
        inactive: 'Inativo'
      },
      generic_theme: {
        path: 'rainbow',
        name: 'Solaris Rainbow',
        developer: 'Solaris Web',
        website: 'https://www.solaris.app.br'
      }
    },
    list: {
      title: 'Temas Disponíveis',
      generic_list: [
        {
          path: 'rainbow',
          name: 'Solaris Rainbow',
          developer: 'Solaris Web',
          website: 'https://www.solaris.app.br'
        },
        {
          path: 'comingsoon',
          name: 'Breve novos Temas',
          developer: 'Solaris Web',
          website: 'https://www.solaris.app.br'
        }
      ]
    }
  },
  permissions: {
    title: 'Permissões'
  },
  defaults: {
    title: 'Predefinições',
    alert: 'Após <strong>Salvar</strong>, será necessário atualizar a página para recarregar alterações.',
    global: {
      title: 'Padrões Globais',
      delivery_fee: 'Taxa de Entrega',
      state: 'Estado',
      city: 'Cidade'
    },
    financial: {
      title: 'Financeiro',
      debit_tax: 'Taxa Cartão de Débito',
      credit_tax: 'Taxa Cartão de Crédito (Antecipado)',
      discount_tax_comissions: 'Descontar Taxas das Comissões',
      rules: {
        tax: [
          v => !!v && parseInt(v) > 0 && parseInt(v) <= 100 || 'Deve ser maior que 0 e menor que 100'
        ]
      }
    },
    customers: {
      title: 'Clientes',
      birthday_text: 'Texto de Aniversário'
    }
  }
}

export default config
